// Bankadan Kasaya Transfer penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.bankToCashTransfer';

export const bankToCashTransferGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Bankadan kasaya transfer nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu pencere, bankadan çektiğiniz nakdi bir kasaya koyduğunuzda kullanılır: para banka hesabından çıkar, seçtiğiniz kasaya girer. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Bankadan Kasaya Transfer'),
    body: t(`${G}.regions.body`, 'Banka, kasa ve tutar'),
    footer: t(`${G}.regions.footer`, 'Kasaya Aktar'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Kaynak banka hesabını kontrol edin'),
      text: t(`${G}.s1.text`, 'Kaynak Banka Hesabı kutusu, transferi başlattığınız hesabı ve mevcut bakiyesini gösterir. Alt hesap satırından açtıysanız para o alt hesaptan çıkar.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Hedef kasayı seçin'),
      text: t(`${G}.s2.text`, 'Hedef Kasa listesinde yalnız banka hesabıyla aynı para birimindeki aktif kasalar görünür. Seçtiğiniz kasanın mevcut bakiyesi altta gösterilir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Şube yöneticisi olarak girdiyseniz yalnız kendi şubenizin kasaları listelenir.'),
        t(`${G}.s2.tip2`, '"Uygun kasa bulunamadı" yazıyorsa bu para biriminde aktif kasanız yoktur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Miktar, açıklama ve tarih'),
      text: t(`${G}.s3.text`, 'Miktarı 1.500,50 biçiminde girin; banka hesabının bakiyesinden fazla olamaz ("Yetersiz bakiye!"). Açıklama isteğe bağlıdır; boş bırakılırsa "Banka → Kasa transfer" yazılır.'),
      tips: [
        t(`${G}.s3.tip1`, '"Geçmiş tarihli işlem yap" işaretlenirse banka ve kasa kayıtları seçtiğiniz tarihe yazılır; ileri tarih seçilemez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Kasaya aktarın'),
      text: t(`${G}.s4.text`, '"Kasaya Aktar" kasa ve geçerli bir miktar girilince açılır. Onaydan sonra tutar banka bakiyesinden düşülür, kasa bakiyesine eklenir. Bankada bir çıkış, kasada bir giriş hareketi oluşur; ikisi aynı belge numarasını (BCT-…) taşır. Pencere kısa bir başarı mesajından sonra kapanır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Hatalı aktarımı düzeltmek için kasadan bankaya ters yönde transfer yapın.'),
      ],
    },
  ],
});
